/**
 * Textos d'Existències (`ca`) — model Lot + Lloc (OBR-142: OBR-143, OBR-146, OBR-14): ajunta els fitxers de cada tall.
 * Cablejat a `ca.ts` amb un sol `...existenciesCa`; així cada tall edita només el seu fitxer.
 */

import { statesCa } from './states.ca.js';
import { stockLineCa } from './stockLine.ca.js';
import { plantaStockCa } from './plantaStock.ca.js';
import { viewsCa } from './views.ca.js';
import { reprintCa } from './reprint.ca.js';
import { countCa } from './count.ca.js';
import { fefoCa } from './fefo.ca.js';
import { receptionDirectCa } from './receptionDirect.ca.js';
import { plantaCountCa } from './plantaCount.ca.js';

export const existenciesCa = {
  ...statesCa,
  ...stockLineCa,
  ...plantaStockCa,
  ...viewsCa,
  ...reprintCa,
  ...countCa,
  ...fefoCa,
  ...receptionDirectCa,
  ...plantaCountCa,
} as const;
